import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import { MARKETPLACE_CONNECTIONS_KEY } from "@/api/use-marketplace-connections";

import type { MarketplaceId } from "../lib/types";

/**
 * POST /v1/marketplace/{marketplace}/disconnect — 204 on success.
 *
 * A status change, not a delete: the shop keeps its row, its history and its
 * encrypted tokens, so the list has to be refetched rather than filtered
 * client-side — the shop stays on screen, with a different badge.
 */
export function useDisconnect() {
  const qc = useQueryClient();
  return useMutation({
    meta: { silentError: true },
    mutationFn: async (marketplace: MarketplaceId): Promise<void> => {
      const { error } = await apiClient.POST("/v1/marketplace/{marketplace}/disconnect", {
        params: { path: { marketplace } },
      });
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: MARKETPLACE_CONNECTIONS_KEY }),
  });
}
